import { Complaint } from '../Complaint'
import { agentImportPermitFraud } from '../../strings/titles'
import { routePaths as routes } from '../../utilities/routePaths'
import { formSchema } from './schema'
import { withBackButtonProtection } from '../../components/withBackButtonProtection'
import { withDocTitle } from '../../components/withDocTitle'
import withRecaptcha from '../withRecaptcha'

export class AgentImportPermitComplaint extends Complaint {
  constructor(props) {
    super(props)
    this.complaintType = 'agent_import_permit_fraud'
    this.schema = formSchema(this.saveFormData)
    this.successURL = routes.agentimportpermitfraud.confirmation
  }
}

export default withRecaptcha(
  withBackButtonProtection(
    withDocTitle(AgentImportPermitComplaint, agentImportPermitFraud)
  )
)
